import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-20 md:py-32 px-6 bg-cream-200" data-id="element-1">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 md:gap-16" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-terracotta" data-id="element-3">
          <h3 className="text-2xl font-serif font-bold text-charcoal mb-6 flex items-center gap-3" data-id="element-4">
            <CheckCircle2 className="text-terracotta w-8 h-8" data-id="element-5" />
            Es para vos si:
          </h3>
          <ul className="space-y-4" data-id="element-6">
            {['te sentís desbordada fácil', 'apretás los dientes', 'el pecho se te sube', "te cuesta bajar incluso cuando 'no pasa nada'", 'querés algo práctico, rápido y sin espiritualidad'].map((item, i) => <li key={i} className="flex items-start text-charcoal-light" data-id="element-7">
                <span className="w-1.5 h-1.5 bg-terracotta rounded-full mt-2.5 mr-3 flex-shrink-0" data-id="element-8" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-cream-300/30 p-8 rounded-2xl border-t-4 border-charcoal-light" data-id="element-9">
          <h3 className="text-2xl font-serif font-bold text-charcoal mb-6 flex items-center gap-3" data-id="element-10">
            <XCircle className="text-charcoal-light w-8 h-8" data-id="element-11" />
            No es para vos si:
          </h3>
          <ul className="space-y-4" data-id="element-12">
            {['buscás diagnóstico médico', 'tenés síntomas severos sin evaluar', "querés 'entender todo' antes de hacer algo (esto es para bajar primero)"].map((item, i) => <li key={i} className="flex items-start text-charcoal-light" data-id="element-13">
                <span className="w-1.5 h-1.5 bg-charcoal-light rounded-full mt-2.5 mr-3 flex-shrink-0" data-id="element-14" />
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}